export default __webpack_public_path__ + "static/media/add_word.8eaa5e20.png";